module.exports = __webpack_public_path__ + "img/zhifubao.586d3a76.png";